var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import ListItem from './ListItem';
var INIT_STATE = function () { };
export var ListDeleteItemContext = React.createContext(INIT_STATE);
var ListemItemStyled = styled(ListItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiListItem-secondaryAction {\n    background-color: ", ";\n    border: ", ";\n  }\n"], ["\n  &.MuiListItem-secondaryAction {\n    background-color: ",
    ";\n    border: ",
    ";\n  }\n"])), function (_a) {
    var _b, _c, _d, _e;
    var hover = _a.hover, theme = _a.theme;
    return hover ? (_c = (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.light : (_e = (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.background) === null || _e === void 0 ? void 0 : _e.hover;
}, function (_a) {
    var _b, _c;
    var hover = _a.hover, theme = _a.theme;
    return hover ? "1px solid " + ((_c = (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.dark) : undefined;
});
var ListItemDelete = function (props) {
    var _a = React.useState(false), hover = _a[0], setHover = _a[1];
    return (React.createElement(ListDeleteItemContext.Provider, { value: setHover },
        React.createElement(ListemItemStyled, __assign({}, props, { hover: hover }))));
};
export default ListItemDelete;
var templateObject_1;
